import * as types from './types';

const modalToggle = payload => {
  return {
    type: types.TOGGLE,
    payload
  }
}

export {
  modalToggle
};



// WEBPACK FOOTER //
// ./src/store/modal/action.js